import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useInboxStore } from '../../../../../stores/inbox/useInboxStore'

const SearchInput: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    const { store: { query }, dispatch } = useInboxStore()
    const [localValue, setLocalValue] = useState(query)

    useEffect(() => {
        setLocalValue(query)
    }, [query])

    const applySearch = (value: string) => {
        const trimmed = value.trim()
        // Parity with linkedinextension useInboxFilters.searchValueChanged — skip single-char queries.
        if (trimmed.length === 1) return
        dispatch({ type: 'set-search-value', payload: trimmed })
    }

    const handleChange = (value: string) => {
        setLocalValue(value)
        // Clearing the field must drop the active search immediately (store only updated on Enter otherwise).
        if (!value.trim()) {
            dispatch({ type: 'set-search-value', payload: '' })
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            applySearch(localValue)
        }
    }

    return (
        <Wrapper>
            <Input
                value={localValue}
                onChange={e => handleChange(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Search messages..."
                disabled={disabled}
            />
            {localValue && (
                <ClearBtn onClick={() => {
                    setLocalValue('')
                    dispatch({ type: 'set-search-value', payload: '' })
                }}>×</ClearBtn>
            )}
            <SearchIcon aria-hidden>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L16.514 16.506M19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="#8ea0b5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </SearchIcon>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 0 13px 0 15px;
    height: 40px;
    background: #fff;
    gap: 8px;
    transition: border-color 0.15s;

    &:focus-within {
        border-color: #b8bfcf;
    }
`
const SearchIcon = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`
const Input = styled.input`
    border: none;
    outline: none;
    background: transparent;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    color: ${props => props.theme.primaryColor};
    flex: 1;
    min-width: 0;
    ::placeholder { color: #9aa8bc; }
    &:disabled { opacity: 0.5; }
`
const ClearBtn = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #9aa8bc;
    padding: 0;
    line-height: 1;
    flex-shrink: 0;
    &:hover { color: #ff6760; }
`

export default SearchInput
